import { backendGet, backendPatch, backendPost } from '../lib/backendClient';

/**
 * Merchant (logista) via backend (unico caminho)
 */
export async function getMerchantOrders(statusFilter = null) {
  const endpoint = statusFilter
    ? `/api/merchant/orders?status_filter=${statusFilter}`
    : '/api/merchant/orders';

  return await backendGet(endpoint);
}

export async function getMerchantMetrics() {
  return await backendGet('/api/merchant/metrics');
}

export async function getMerchantFinanceOverview(params = {}) {
  const query = new URLSearchParams();
  if (params.date_from) query.set('date_from', String(params.date_from));
  if (params.date_to) query.set('date_to', String(params.date_to));
  if (params.status) query.set('status', String(params.status));
  if (params.payment) query.set('payment', String(params.payment));
  if (params.q) query.set('q', String(params.q));
  if (params.limit != null) query.set('limit', String(params.limit));
  const suffix = query.toString() ? `?${query.toString()}` : '';
  return await backendGet(`/api/merchant/finance/overview${suffix}`);
}

export async function getMerchantPayoutAccount() {
  return await backendGet('/api/merchant/finance/payout-account');
}

export async function updateMerchantPayoutAccount(payload) {
  return await backendPost('/api/merchant/finance/payout-account', payload);
}

export async function verifyMerchantPayoutPassword(password) {
  return await backendPost('/api/merchant/finance/payout-account/verify-password', {
    password,
  });
}

export async function getMerchantFinanceReport(period = 'monthly') {
  const query = new URLSearchParams();
  query.set('period', period === 'weekly' ? 'weekly' : 'monthly');
  return await backendGet(`/api/merchant/finance/report?${query.toString()}`);
}

export async function getMerchantVoucherCommissions(params = {}) {
  const query = new URLSearchParams();
  if (params.status) query.set('status', String(params.status));
  if (params.limit != null) query.set('limit', String(params.limit));
  const suffix = query.toString() ? `?${query.toString()}` : '';
  return await backendGet(`/api/merchant/finance/voucher-commissions${suffix}`);
}

export async function getMerchantVoucherSettings() {
  return await backendGet('/api/merchant/voucher/settings');
}

export async function upsertMerchantVoucherSettings(payload) {
  return await backendPost('/api/merchant/voucher/settings', payload);
}

export async function getMerchantTaxProfile() {
  return await backendGet('/api/merchant/tax-profile');
}

export async function upsertMerchantTaxProfile(payload) {
  return await backendPost('/api/merchant/tax-profile', payload);
}

export async function updateOrderStatus(orderId, newStatus) {
  return await backendPatch(`/api/merchant/orders/${orderId}/status`, {
    status: newStatus
  });
}

export async function confirmOrderPickup(orderId, code) {
  return await backendPost(`/api/merchant/orders/${orderId}/pickup-confirm`, {
    code
  });
}

export async function generateMerchantCashReturnCode(orderId) {
  return await backendPost(`/api/merchant/orders/${orderId}/cash-return/code`, {});
}


export async function listOnlineCouriers(params = {}) {
  const { lat, lng, radiusM } = params || {};
  const qs = new URLSearchParams();
  if (lat != null && lng != null) {
    qs.set('lat', String(lat));
    qs.set('lng', String(lng));
    if (radiusM != null) {
      qs.set('radius_m', String(radiusM));
    }
  }
  const suffix = qs.toString() ? `?${qs.toString()}` : '';
  return await backendGet(`/api/merchant/couriers/online${suffix}`);
}

export async function assignCourier(orderId, courierId) {
  return await backendPost(`/api/merchant/orders/${orderId}/assign-courier`, {
    courier_id: courierId
  });
}

export const MERCHANT_ORDER_STATUS = {
  pending: { label: 'Novo', color: '#fbbf24', next: 'confirmed' },
  confirmed: { label: 'Confirmado', color: '#60a5fa', next: 'preparing' },
  preparing: { label: 'Preparando', color: '#f97316', next: 'ready' },
  ready: { label: 'Pronto', color: '#22c55e', next: null },
  awaiting_pickup: { label: 'Aguardando retirada', color: '#f59e0b', next: null },
  out_for_delivery: { label: 'Saiu para entrega', color: '#8b5cf6', next: null },
  delivered: { label: 'Entregue', color: '#10b981', next: null },
  cancelled: { label: 'Cancelado', color: '#ef4444', next: null }
};

export function getNextStatus(currentStatus) {
  return MERCHANT_ORDER_STATUS[currentStatus]?.next || null;
}

export function canAdvanceStatus(currentStatus) {
  return MERCHANT_ORDER_STATUS[currentStatus]?.next !== null;
}
